// extracted by mini-css-extract-plugin
module.exports = {"collapse":"collapse-module--collapse--1OkSe","show":"collapse-module--show--2ilLs","collapsing":"collapse-module--collapsing--1bWjC"};